import Vue from 'vue'

import { Device, Driver } from '@/types/device'
import {
  Find,
  Delete,
  Create,
  Patch,
  Put,
  FindDriver,
  ACTCONNET,
  ACTDISCONNECT,
} from '@/api/device'

import VueContext from 'vue-context'
import 'vue-context/src/sass/vue-context.scss'

interface SelectOptions {
  text: string
  value: number | string
}

interface DriverDictionary {
  [name: string]: Driver
}

export default Vue.extend({
  components: { VueContext },
  data() {
    return {
      selectedDevice: {} as Device,
      newDevice: { name: '', driver: '' } as Device,
      drivers: {} as DriverDictionary,
      optsDrivers: [] as SelectOptions[],
      devices: [] as Device[],
    }
  },
  methods: {
    async FindDrivers() {
      const drivers = await FindDriver()
      for (const i in drivers) {
        this.drivers[drivers[i].name] = drivers[i]
      }
    },
    async createDevice() {
      await Create(this.newDevice)

      this.clearNewDevice()

      await this.findDevice()
      this.$toast.success('Device added.')
    },
    async findDevice() {
      this.clearSelected()
      this.devices = await Find()

      const opts: SelectOptions[] = []
      for (const name in this.drivers) {
        opts.push({
          text: this.drivers[name].title,
          value: this.drivers[name].name,
        })
      }
      this.optsDrivers = opts
    },
    async patch(id: number, device: Device) {
      await Patch(id, device)
      await this.findDevice()
      this.$toast.success('Device updated.')
    },
    async deleteDevice(id: number) {
      await Delete(id)
      await this.findDevice()
      this.$toast.success('Device deleted.')
    },
    async putConnect() {
      const toast = this.$toast.info(
        `starting ${this.selectedDevice.name}...`,
        {
          dismissible: false,
          duration: 60000,
        }
      )
      try {
        await Put(this.selectedDevice.id, ACTCONNET)
        toast.close()
        this.$toast.success(`Success. ${this.selectedDevice.name} connected.`)
      } catch {
        toast.close()
        this.$toast.error(`Failed to start ${this.selectedDevice.name}!`)
      }
    },
    async putDisconnect() {
      const toast = this.$toast.info(
        `Diconnecting with ${this.selectedDevice.name}...`,
        {
          dismissible: false,
          duration: 60000,
        }
      )
      try {
        await Put(this.selectedDevice.id, ACTDISCONNECT)
        toast.close()
        this.$toast.success(
          `Success. ${this.selectedDevice.name} disconnected.`
        )
      } catch {
        toast.close()
        this.$toast.error(
          `Failed to send disconnect request with ${this.selectedDevice.name}!`
        )
      }
    },
    clearNewDevice() {
      this.newDevice = {
        id: 0,
        name: '',
        driver: '',
        config: {},
        description: '',
        enabled: false,
        isGroup: false,
        groupId: null,
      }
    },
    clearSelected() {
      this.selectedDevice = {
        id: -1,
        name: '',
        driver: '',
        config: {},
        description: '',
        enabled: false,
        isGroup: false,
        groupId: null,
      }
    },
  },
  watch: {
    'newDevice.driver': function() {
      //
    },
  },
  async created() {
    await this.FindDrivers()
    await this.findDevice()
  },
})
